<template>
  <BaseModal
    :id="`modal__view_video-${index}`"
    :show.sync="$show"
    :title="post ? post.title : `Unknown`"
    :size="'xl'"
    :hide-footer="true"
    :centered="true"
    :is-fullscreen="false"
  >
    <b-row id="ViewVideoAndChatModal" class="h-100">
      <b-col cols="12" class="my-2">
        <div class="view-video-chat-modal__wrapper d-flex flex-wrap">
          <BaseVideoPlayer
            class="view-video-chat-modal__player"
            :video="meetingRecord.vimeo"
            :options="videoOptions"
          >
          </BaseVideoPlayer>

          <div class="view-video-chat-modal__chat">
            <BaseChatMessage
              v-if="meetingRecord.chat"
              :link="meetingRecord.chat.url"
              :active-custom-class="true"
            >
            </BaseChatMessage>

            <b-list-group v-else class="h-100">
              <b-list-group-item>
                <b class="text__chat-box-title">Chat Messages</b>
              </b-list-group-item>
              <b-list-group-item class="p-0 h-100">
                <b-card
                  class="font-weight-bold h-100 d-flex flex-row align-items-center bg-transparent card-transparent"
                >
                  <b-card-text class="text-center"> No chat messages available </b-card-text>
                </b-card>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
import BaseVideoPlayer from '@/components/base-components/BaseVideoPlayer';
import BaseChatMessage from '@/components/base-components/BaseChatMessage';
import Post from '@/models/Post';
export default {
  name: 'ViewVideoAndChatModal',

  components: {
    BaseModal,
    BaseVideoPlayer,
    BaseChatMessage
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    post: {
      type: Post,
      default: null
    },

    meetingRecord: {
      type: Object,
      required: true
    },

    index: {
      type: [Number, String],
      default: 0
    }
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    videoOptions() {
      return {
        responsive: true
        // height: "100%"
      };
    }
  }
};
</script>

<style lang="scss">
#ViewVideoAndChatModal {
  // height: 80vh !important;

  .view-video-chat-modal {
    &__wrapper {
      position: relative;
    }

    &__player {
      width: calc(70% - 1rem) !important;
      margin-right: 1rem;
    }

    &__chat {
      width: 30%;
    }
  }

  .list-group__chat-box {
    position: absolute;
    top: 41px;
    max-height: calc(100% - 41px);
    width: 100%;
    overflow: auto;
  }
}

// @media (min-width: 1199.98px) {
//   .player__vimeo {
//     >div {
//       // padding: 100% 0 0 0 !important;
//       background-color: #070919;
//     }
//   }
// }

@media (max-width: 991.98px) {
  #ViewVideoAndChatModal {
    .list-group__chat-box {
      max-height: 50vh;
      overflow: auto;
    }
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  #ViewVideoAndChatModal {
    .list-group__chat-box {
      max-height: 40vh;
      overflow: auto;
    }
  }
}

@media (max-width: 1199.98px) {
  #ViewVideoAndChatModal {
    min-height: 80vh !important;

    .view-video-chat-modal {
      &__wrapper {
        flex-flow: column nowrap;
      }

      &__player {
        width: 100% !important;
        margin-right: 0;
      }

      &__chat {
        width: 100%;
        margin-top: 1rem;
        flex-grow: 1;
      }
    }

    .list-group__chat-box {
      position: relative;
      top: 0;
    }
  }
}

@media (min-width: 1200px) and (orientation: landscape) {
  #ViewVideoAndChatModal {
    .view-video-chat-modal {
      &__wrapper {
        max-height: 410px;
      }
    }
  }
}

// @media (max-width: 1199.98px) and (orientation: landscape) {
//   .modal-dialog {
//     max-width: 80vw !important;
//   }

//   #ViewVideoAndChatModal {
//     height: 100% !important;

//     .view-video-chat-modal {
//       &__wrapper {
//         flex-flow: row nowrap;
//       }

//       &__player {
//         width: calc(70% - 1rem) !important;
//         margin-right: 1rem !important;
//       }

//       &__chat {
//         width: 30%;
//         margin-top: 0 !important;
//         flex-grow: 1;
//       }
//     }

//     // .modal-content {
//     //   height: 90vh;
//     // }
//   }
// }
</style>
